/**
 * Convert a date-input value (YYYY-MM-DD) to an ISO timestamp for the start
 * or end of that calendar day in the user's local timezone.
 *
 * Avoids `new Date("YYYY-MM-DD")`, which is always parsed as UTC midnight and
 * shifts the filter by one day for timezones east/west of UTC.
 */
export function localDayBoundaryIso(
  dateStr: string,
  boundary: 'start' | 'end',
): string | undefined {
  if (!dateStr) return undefined;
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr.trim());
  if (!match) return dateStr;

  const year = Number(match[1]);
  const month = Number(match[2]) - 1;
  const day = Number(match[3]);

  const local =
    boundary === 'start'
      ? new Date(year, month, day, 0, 0, 0, 0)
      : new Date(year, month, day, 23, 59, 59, 999);

  return local.toISOString();
}
